import { render, staticRenderFns } from "./PhotoUploadHistoryMedia.vue?vue&type=template&id=f57d2ee4&"
import script from "./PhotoUploadHistoryMedia.vue?vue&type=script&lang=ts&"
export * from "./PhotoUploadHistoryMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCol,VImg})
